import { api } from '@/app/api'

export interface OnboardingStatus {
  needs_onboarding: boolean
  steps: {
    password: boolean
    branding: boolean
    integrations: boolean
  }
  company: {
    uuid: string
    name: string
    logo_url: string | null
    brand_primary_color: string | null
    brand_secondary_color: string | null
    industry_template_code: string | null
    onboarding_completed_at: string | null
  }
}

export interface CredentialInput {
  group: string
  key: string
  value: string
}

export const onboardingApi = api.injectEndpoints({
  endpoints: (build) => ({
    onboardingStatus: build.query<{ data: OnboardingStatus }, void>({
      query: () => '/v1/onboarding/status',
      providesTags: ['Auth'],
    }),
    onboardingChangePassword: build.mutation<
      unknown,
      { current_password: string; new_password: string; new_password_confirmation: string }
    >({
      query: (body) => ({ url: '/v1/auth/change-password', method: 'POST', body }),
      invalidatesTags: ['Auth'],
    }),
    onboardingBranding: build.mutation<unknown, FormData>({
      query: (body) => ({ url: '/v1/onboarding/branding', method: 'POST', body }),
      invalidatesTags: ['Auth'],
    }),
    onboardingIntegrations: build.mutation<unknown, { credentials: CredentialInput[] }>({
      query: (body) => ({ url: '/v1/onboarding/integrations', method: 'POST', body }),
      invalidatesTags: ['Auth'],
    }),
    onboardingComplete: build.mutation<unknown, void>({
      query: () => ({ url: '/v1/onboarding/complete', method: 'POST' }),
      invalidatesTags: ['Auth'],
    }),
  }),
})

export const {
  useOnboardingStatusQuery,
  useOnboardingChangePasswordMutation,
  useOnboardingBrandingMutation,
  useOnboardingIntegrationsMutation,
  useOnboardingCompleteMutation,
} = onboardingApi
